<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="backlink-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!backlink_id">バックリンク追加</h5>
                    <h5 class="modal-title" v-else>バックリンク編集</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label>バックリンクURL</label>
                        <div class="backlink">
                            <input type="text" ref="backlinkUrl" class="form-control" v-model="backlink.url"
                                data-toggle="dropdown"
                                placeholder="リンク先URL"
                                @keydown.ctrl.enter="save()" />
                            <div class="dropdown-menu">
                                <a href="#" class="dropdown-item"
                                    v-for="(s, domain) in searches" :key="domain"
                                    @click.prevent="setUrl(s.url)">
                                    {{ s.name }}
                                    <span class="badge badge-primary" v-if="s.official">公式</span>
                                    <span class="badge badge-danger" v-else>非公式</span>
                                </a>
                            </div>
                        </div>
                        <div class="text-muted small">
                            リンク先URLです。
                        </div>
                        <div class="text-primary small" v-if="search && search.official">
                            この創作サーチは貸し本棚の登録を認めています。
                        </div>
                        <div class="text-warning small" v-else-if="search && !search.official">
                            この創作サーチは貸し本棚の登録を公式には認めていませんが、登録は可能です。
                        </div>
                    </div>
                    <div class="mb-3">
                        <label>バックリンク名</label>
                        <input type="text" class="form-control" :value="searchName" v-if="searchName" readonly>
                        <input type="text" class="form-control" v-model="backlink.link_name" placeholder="リンク先名" @keydown.ctrl.enter="save()" v-else />
                        <div class="text-muted small">
                            テキストで表示される名称です。
                        </div>
                    </div>
                    <div class="mb-3">
                        <label>リンクバナー</label>
                        <div v-if="searchBanner">
                            <img :src="'/img/search/' + searchBanner" class="img-thumbnail link-img mb-2">
                        </div>
                        <div v-else>
                            <div v-if="link.url">
                                <img :src="link.url" class="img-thumbnail link-img mb-2" />
                                <div class="input-group" v-if="link.url.match(/^http/)">
                                    <input type="text" :value="link.url" class="form-control form-control-sm" readonly>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary btn-sm" @click="copy(link.url)">
                                            <i class="far fa-copy"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="py-2">
                                <div class="btn-group file-selector">
                                    <label class="btn btn-secondary m-0">
                                        <i class="fas fa-file-image"></i>
                                        リンクバナー画像選択...
                                        <input type="file" ref="link" @change="linkSelected" accept="image/*" class="d-none" />
                                    </label>
                                    <button type="button" @click="removeLink" class="btn btn-light">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                            <div class="small">
                                <ul>
                                    <li>200 x 40サイズのバックリンク専用バナーです。</li>
                                    <li>推奨サイズは幅200px 高さ40pxです。</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存 (ctrl + Enter)</button>
                </div>
            </div>
        </div>
        <loading
            v-model:active="isLoading"
            :can-cancel="false"
            :is-full-page="true"></loading>
    </div>
</template>

<script>
import searchServices from "@/searchServices";
export default {
    props: {
        backlink_id: {
            default: null
        }
    },
    data() {
        return {
            backlink: {},
            link: {
                info: null,
                url: null,
            },
            isLoading: false,
            searches: searchServices,
        }
    },
    methods: {
        load() {
            this.backlink = {};
            this.link = {
                info: null,
                url: null,
            };
            if (! this.backlink_id) {
                return
            };
            axios.get("/mypage/backlinks/backlink", {params: {id: this.backlink_id}}).then(res => {
                this.backlink = res.data;
                if (this.backlink.picture) {
                    this.link.url = this.backlink.picture.url + '?' + this.backlink.picture.hash;
                }
            }).catch(err => {
                alert.err(err.response);
            });
        },
        save() {
            this.isLoading = true;
            const fd = new FormData();
            if (this.searchName) {
                // 既定サイト
                this.backlink.link_name = this.searchName;
            } else {
                // 新規サイト
                fd.append('link', this.link.info);
                fd.append('link_url', this.link.url);
            }
            for (const key in this.backlink) {
                fd.append(key, this.backlink[key]);
            }
            axios.post("/mypage/backlinks/save", fd).then(res => {
                this.$emit("saved");
                this.backlink = {};
                $("#backlink-modal").modal("hide");
                alert.msg("バックリンクを保存しました。");
                this.isLoading = false;
            }).catch(err => {
                alert.err(err);
                this.isLoading = false;
            });
        },
        linkSelected() {
            if (this.$refs.link.files[0].size > 500 * 1024) {
                alert.err("ファイルサイズが大きすぎます: " + this.getSize(this.$refs.link.files[0].size));
                return;
            }
            this.link.info = this.$refs.link.files[0];
            this.link.url = URL.createObjectURL(this.link.info);
        },
        removeLink() {
            this.link.info = null;
            this.link.url = "";
        },
        setUrl(url) {
            this.backlink.url = url;
        },
    },
    computed: {
        searchBanner() {
            if (this.backlink.url) {
                for (const domain in this.searches) {
                    const regex = new RegExp(domain, "i");
                    if (this.backlink.url.match(regex)) {
                        return this.searches[domain].banner;
                    }
                }
            }
            return null;
        },
        searchName() {
            if (this.backlink.url) {
                for (const domain in this.searches) {
                    const regex = new RegExp(domain, "i");
                    if (this.backlink.url.match(regex)) {
                        return this.searches[domain].name;
                    }
                }
            }
            return null;
        },
        search() {
            if (this.backlink.url) {
                for (const domain in this.searches) {
                    const regex = new RegExp(domain, "i");
                    if (this.backlink.url.match(regex)) {
                        return this.searches[domain];
                    }
                }
            }
            return null;
        },
    },
    mounted() {
        $("#backlink-modal").on("show.bs.modal", (e) => {
            this.load();
        });
        $("#backlink-modal").on("shown.bs.modal", (e) => {
            this.$refs.backlinkUrl.focus();
        });
        $("#backlink-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>